// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App';
import Router from 'vue-router';
import router from './router';
import ElementUI from 'element-ui';
// 导入ElementUI的语言包
import enLocale from 'element-ui/lib/locale/lang/en';
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
import ElementLocale from 'element-ui/lib/locale';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import 'jquery';
import store from './store/index.js';
import axios from 'axios';
import echarts from 'echarts';
import './common/js/tool.js';
import './assets/js/calendar.js';
import './common/js/rem.js';
import sessionTimeout from './common/js/sessionTimeout';

// 引入 vue-video-player
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

// 引入图标字体
import './assets/css/reset.css';
import './assets/css/iconfont.css';
import './assets/css/global.scss';
// 日期组件
import './assets/css/BeatPicker.min.css';
import './assets/css/calendar.css';
// import './assets/js/BeatPicker.min.js';
// import './assets/js/prism.js';

// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 定义全局变量
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;

// 先注册VueI18n
Vue.use(VueI18n);

// 合并ElementUI的语言包和我们自己的翻译
import zhCN from './i18n/zh-CN';
import zhTW from './i18n/zh-TW';
import enUS from './i18n/en-US';

const messages = {
  'en-US': {
    ...enUS,
    ...enLocale
  },
  'zh-CN': {
    ...zhCN,
    ...zhCNLocale
  },
  'zh-TW': {
    ...zhTW,
    ...zhTWLocale
  }
};

// 获取本地存储中保存的语言设置或默认使用浏览器语言
const getDefaultLanguage = () => {
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // 如果没有保存的语言设置，使用浏览器语言或默认使用英文
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('zh')) {
    if (browserLang.includes('TW') || browserLang.includes('HK')) {
      return 'zh-TW';
    } else {
      return 'zh-CN';
    }
  } else if (browserLang.startsWith('en')) {
    return 'en-US';
  } else if (browserLang.startsWith('CN')) {
    return 'zh-CN';
  }
  
  return 'zh-CN'; // 默认使用中文
};

// 创建新的Vue I18n实例
const i18n = new VueI18n({
  locale: getDefaultLanguage(),
  fallbackLocale: 'zh-TW',
  messages,
  silentTranslationWarn: true
});

// 设置ElementUI国际化
ElementLocale.i18n((key, value) => i18n.t(key, value));
Vue.use(ElementUI);

Vue.use(VideoPlayer);
Vue.use(Router);

Vue.config.productionTip = false;

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
});

// 将 Vue 实例挂载到 window 上，供 sessionTimeout 使用
window.Vue = Vue;

// 初始化会话超时监控
app.$nextTick(() => {
  sessionTimeout.init();
});



// WEBPACK FOOTER //
// ./src/main.js